<template>
  <div class="row about-wrapper">
    <header-about />
    <div class="mensagem-about-1">
      <div v-if="entidade_banner" class="banner">
        <img :src="entidade_banner" alt="entidade_banner" width="30%">
      </div>
      <div v-else>
        <h4>O melhor app para auto-recadastramento previdenciário, na web e no smartphone.</h4>
        <p>
          Para mais informações sobre as campanhas de recenseamento em andamento acesse 
          <router-link to="/Ajuda/">esta página</router-link>.
        </p>
      </div>
      <router-link to="/Censo/" class="waves-effect waves-light btn btn-theme fAboutLogin" id="abouBtnLogin">Iniciar recenseamento</router-link>
    </div>
    <div class="hide-on-med-and-down mensagem-about-2">
      <p>A mesma experiência, em qualquer plataforma</p>
      <img class="center-align img-thumb-about" src="@/assets/img/HTML5_logo_and_wordmark.svg" alt="Marca" />
      <a target="_blank" href="https://play.google.com/store/apps/details?id=br.com.grupobra.censo">
        <img class="center-align img-thumb-about" src="@/assets/img/android.svg" alt="Marca" />
      </a>
      
      <a target="_blank" href="https://apple.co/3nTYkIV">
        <img class="center-align img-thumb-about apple" src="@/assets/img/apple-black.svg" alt="Marca" />
      </a>
    </div>
    <cookies-accept-decline/>
    <div class="mascara"></div>
  </div>
</template>
<script>
import HeaderAbout from "@/components/HeaderAbout.vue"
import CookiesAcceptDecline from "@/components/CookiesAcceptDecline.vue"

export default {
  name: "About",
  components: {
    "header-about": HeaderAbout,
    "cookies-accept-decline": CookiesAcceptDecline
  },
  data() {
    return {
      hostname: "",
      entidade_banner: ""
    }
  },
  methods: {
    setup_domain(){
      if(this.$store.state.meta.data.host){
        this.entidade_banner = this.$store.state.meta.data.censo_domain_banner
      }
    }
  },
  mounted() {
    this.setup_domain()
    this.$root.$emit("stopLoadingHeader")
  }
}
</script>

<style>
  .recad {
    overflow: hidden;
  }
  #abouBtnLogin {
    margin-top: 2%;
    width: 15%;
  }

  @media (max-width: 744px) {
    .logos > img{
      width: 100%;
    }
    .banner > img {
      width: 100%;
    }
    #abouBtnLogin {
      margin-top: 2%;
      width: 100%;
    }
  }

  @media (min-width: 745px) and (max-width: 1200px) {
    .logos > img{
      width: 30%;
    }
    #abouBtnLogin {
      margin-top: 2%;
      width: 40%;
    }
  }

</style>


// WEBPACK FOOTER //
// src/components/About.vue